module.exports = __webpack_public_path__ + "img/benjike7.28f47f08.png";